module.exports = __webpack_public_path__ + "static/pic6-37b2b4a07bfdfc9e01635ebb186d4318.jpg";